import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { Typography } from '@/components/typography/typography'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { translate } from '@/utils/translator'

import { SUPPORT_CODE_QUERY_KEY, useSupportCode } from '../hooks/useSupportCode'

export const SupportCode = () => {
	const { data, refetch } = useSupportCode()
	const cartStoreData = useCartStore()
	const queryClient = useQueryClient()

	useEffect(() => {
		queryClient.resetQueries({ queryKey: [SUPPORT_CODE_QUERY_KEY], exact: true })
	}, [cartStoreData, queryClient])

	return (
		<div>
			{!data && (
				<button onClick={() => refetch()}>
					<Typography element="span" style="p-ms">
						{translate('footer-navigation-get-support-code')}
					</Typography>
				</button>
			)}
			{data && (
				<div>
					<Typography element="p" style="p-ms">
						{translate('footer-navigation-support-code')}: {data.helpCode}
					</Typography>

					<Typography element="p" style="p-ms">
						{translate('footer-navigation-support-code-description')}
					</Typography>

					<a href="tel:+49 40 300322-366">
						<Typography element="p" style="p-ms" className="underline">
							+49 40 300322-366
						</Typography>
					</a>
				</div>
			)}
		</div>
	)
}
